import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import type { Props } from "./OverlayGradientV1.types.ts";

defineComponent<Props>({
  tag: "oc-overlay-gradient-v1",
  extendOptions: { useShadow: false },
  styles: () => import("./OverlayGradientV1.global.scss?inline"),
  props: {
    colorContrast: {
      attribute: "color-contrast",
      reflect: true,
    },
    alignment: {
      reflect: true,
    },
  },
});
